import React, {useState} from 'react'
import { styled } from "styled-components"
import {
  BtnBold,
  BtnItalic,
  BtnLink,
  BtnStrikeThrough,
  Editor,
  EditorProvider,
  Toolbar
} from 'react-simple-wysiwyg';
import { handlePasteClean } from '~/utils/textCleaner';

const Wrapper = styled.div`
  padding-right: 20px;
  margin-bottom: 12px;
  
  label {
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
    text-align: left;
  }
  
  ol {
    padding-left: 14px;
  }
  
  ul {
    padding-left: 14px;
  }
`;

const Text = ({ id, label, content, onChangeEvent, type }) => {
  const [value, setValue] = useState(content || '');

  const onChange = (e) => {
    setValue(e.target.value);

    if (onChangeEvent) {
      onChangeEvent(id, e.target.value, type);
    }
  };

  const onPaste = (e) => {
    handlePasteClean(e, setValue, onChangeEvent, id, type);
  };

  return (
    <Wrapper>
      <label>{label ? `${label}: ` : ''}</label>
      <EditorProvider>
        <Editor value={value} onChange={onChange} onPaste={onPaste}>
          <Toolbar>
            <BtnBold />
            <BtnItalic />
            {/*<BtnBulletList />*/}
            {/*<BtnNumberedList />*/}
            <BtnLink />
            <BtnStrikeThrough />
          </Toolbar>
        </Editor>
      </EditorProvider>
    </Wrapper>
  );
};

export default Text;
